import {useState} from "react";
import Axios from "axios";
import {API, ENDPOINTS} from "../../../network/API";
import {AuthUtil} from "../../../util/AuthUtil";
import {AlertModal} from "../../alertmodal/AlertModal";
import {Chronos} from "../../../chronos/Chronos";
import {DataManager} from "../../../data/DataManager";
import Rosetta from "../../../rosetta/Rosetta";

import "./SecureLoginPromptScreen.css";

import iconSecure from "../../../assets/images/icon_encrypted.svg";
import {ImageUtil} from "../../../util/ImageUtil";
import {Navigator} from "../../../util/Navigator";
import {LoadingSpinner} from "../../loading/LoadingSpinner";

export const SecureLoginPromptScreen = (props) => {

    const [error, setError] = useState(null);
    const [registerSuccess, setRegisterSuccess] = useState(false);

    const [networkInFlight, setNetworkInFlight] = useState(false);

    function moveOn() {
        let out = "/";

        let redirect = Navigator.getHashParam("r", null);
        if (redirect !== null) {
            out += redirect.replaceAll("-", "/");
        }

        Navigator.navigate(out);
    }

    function requestSecureLoginOverNetwork() {
        if (networkInFlight) return;
        setNetworkInFlight(true);

        const formData = new FormData();
        formData.append("source", "1");

        Axios.post(ENDPOINTS.auth.requestSecureRegistration, formData)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    AuthUtil.createSecureRegistrationResponse(
                        resp.data.options,
                        resp.data.challenge,
                        (success, data) => {
                            if (success) {
                                submitSecureLoginOverNetwork(resp.data.identifier, data);
                            } else {
                                if (data) {
                                    AlertModal.showError(data);
                                }
                            }
                        });
                } else {
                    setError(API.formatError(resp));
                }
                setNetworkInFlight(false);
            })
            .catch((e) => {
                console.log(e);
                setNetworkInFlight(false);
                setError(API.defaultError("RSR1000C"));
            });
    }

    function submitSecureLoginOverNetwork(identifier, response) {
        const formData = new FormData();
        formData.append("identifier", identifier);
        formData.append("options", response);

        Axios.post(ENDPOINTS.auth.registerSecureLogin, formData)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    const expires = Chronos.now().add(3, Chronos.MONTHS).seconds();
                    DataManager.setSecureLoginData({
                        identifier : resp.data.identifier,
                        expires
                    });

                    setRegisterSuccess(true);
                } else {
                    console.log(API.formatError(resp));
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // RENDER

    let buttonElems = [
        <div className={"row mt-4"}>
            <div className={"col-12 text-center"}>
                <button className={"btn btn-secure"} onClick={() => requestSecureLoginOverNetwork()}>
                    <span className={"icon"} style={{backgroundImage : ImageUtil.background(iconSecure)}} />
                    {Rosetta.string("login.webauth_register_submit")}
                </button>
            </div>
        </div>,

        <div className={"row mt-2"}>
            <div className={"col-12 text-center"}>
                <button className={"btn btn-outline-secondary"} onClick={() => moveOn()}>
                    {Rosetta.string("login.webauth_register_later")}
                </button>
            </div>
        </div>
    ];

    if (networkInFlight) {
        buttonElems = (
            <div className={"row"}>
                <div className={"col-12 text-center"}>
                    <LoadingSpinner inline={true} small={true} />
                </div>
            </div>
        );
    }

    let mainContent = (
        <>
            <div className={"row"}>
                <div className={"col-12 text-center"}>
                    <h5>{Rosetta.string("login.webauth_register_title")}</h5>
                </div>
            </div>

            <div className={"row mt-1"}>
                <div className={"col-12 text-center"}>
                    {Rosetta.string("login.webauth_register_message")}
                </div>
            </div>

            {buttonElems}
        </>
    );

    if (registerSuccess) {
        mainContent = (
            <>
                <div className={"row"}>
                    <div className={"col-12 text-center"}>
                        <h5>{Rosetta.string("login.webauth_register_success_title")}</h5>
                    </div>
                </div>

                <div className={"row mt-1"}>
                    <div className={"col-12 text-center"}>
                        {Rosetta.string("login.webauth_register_success_message")}
                    </div>
                </div>

                <div className={"row mt-4"}>
                    <div className={"col-12 text-center"}>
                        <button className={"btn btn-success"} onClick={() => moveOn()}>{Rosetta.string("common.ok")}</button>
                    </div>
                </div>
            </>
        )
    }

    return (
        <div className={"secure-register-screen container app-screen animate-screen-content"}>

            <div className={"row justify-content-center mt-4"}>
                <div className={"col-12 col-lg-8 col-xl-6"}>

                    <div className={"row"}>
                        <div className={"col-12"}>
                            <div className={"card"}>
                                <div className={"card-img-top secure-login-graphic-phrase"}>
                                    <div className={"secure-login-overlay"} style={{backgroundImage : ImageUtil.background(iconSecure)}} />
                                </div>

                                <div className={"card-body"}>
                                    {mainContent}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )

}